var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "box-typical-body panel-body",
      staticStyle: { overflow: "hidden" }
    },
    [
      _c(
        "ul",
        { staticClass: "nav nav-tabs justify-content-center" },
        _vm._l(_vm.types, function(type) {
          return _c("li", { key: type, staticClass: "nav-item" }, [
            _c(
              "a",
              {
                class: ["nav-link", _vm.eventType == type ? "active" : ""],
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function() {
                    return (_vm.eventType = type)
                  }
                }
              },
              [_vm._v(_vm._s(type))]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _vm.initialized
            ? _c("table-component", {
                attrs: {
                  content: _vm.content,
                  timestamp: _vm.timestamp,
                  selected: _vm.selected,
                  config: _vm.config,
                  query: _vm.query,
                  updateBatch: _vm.doNothing,
                  addNotification: _vm.doNothing,
                  changeQuery: _vm.changeQuery,
                  changeUrl: _vm.doNothing,
                  onInitialized: _vm.doNothing,
                  onSelected: _vm.doNothing
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.eventType == "click" && !_vm._.isEmpty(_vm.urlReport.items)
            ? [
                _c("hr"),
                _vm._v(" "),
                _c("h4", [_vm._v("Summary of URLs clicked")]),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    striped: "",
                    hover: "",
                    bordered: "",
                    fields: _vm.urlReport.fields,
                    items: _vm.urlReport.items
                  }
                })
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bac7d0d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bac7d0d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/cms/js/components/report/MessageTableComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bac7d0d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/cms/js/components/report/MessageTableComponent.vue
// module chunks = 0